import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {UIGamePlayerInformationCityImprovementProgressTrackerView} from './UIGamePlayerInformationCityImprovementProgressTrackerView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {MechanicCityImprovementsState, PlayerColor} from '@colonist/game-states'

export abstract class UIGameCityImprovementProgressTrackerController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected readonly cityImprovementsState: MechanicCityImprovementsState

    private playerInformationCityImprovementTrackerViews: UIGamePlayerInformationCityImprovementProgressTrackerView[]

    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState) {
        this.uiGameManager = uiGameManager
        this.cityImprovementsState = cityImprovementsState
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerInformationCityImprovementTrackerViews = []

        this.initPlayerCityImprovementTrackerViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.initPlayerCityImprovementTrackerViews(); break
            default: break
        }
    }

    private initPlayerCityImprovementTrackerViews() {
        if(this.uiGameManager.playersController == undefined) return
        this.playerInformationCityImprovementTrackerViews.forEach((view) => view.destroy())
        this.playerInformationCityImprovementTrackerViews = []

        for(const playerColorString of Object.keys(this.cityImprovementsState)) {
            const playerColor = parseInt(playerColorString, 10) as PlayerColor
            const playerInformation = this.uiGameManager.playersController.getPlayerInformationViewWithColor(playerColor)
            if(playerInformation == undefined) continue

            const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
            const isMyPlayer = playerColor == bottomPlayerColor
            const newPlayerInformationCityImprovementProgressTrackerView = isMyPlayer ? this.getMyCityImprovementProgressTrackerSectionView(playerInformation) : this.getOpponentCityImprovementProgressTrackerSectionView(playerInformation)
            this.playerInformationCityImprovementTrackerViews.push(newPlayerInformationCityImprovementProgressTrackerView)
            if(UIUtilsEjsVariables.isUserOnMobileApp) continue
            const tipTitle: TranslationObject = {key: 'strings:game.tips.cityImprovementButton.title'}
            const tipBody: TranslationObject[] = [{key: 'strings:game.tips.cityImprovementButton.body.0'}, {key: 'strings:game.tips.cityImprovementButton.body.1'}]
            newPlayerInformationCityImprovementProgressTrackerView.setTip(tipTitle, tipBody)
        }
    }

    protected abstract getMyCityImprovementProgressTrackerSectionView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationCityImprovementProgressTrackerView
    protected abstract getOpponentCityImprovementProgressTrackerSectionView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationCityImprovementProgressTrackerView
}
